import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import translate from "@insite/client-framework/Translate";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { connect } from "react-redux";
import PrintIcon from "@NA/Icons/PrintIcon";
import OrderDetailsArrowLeft from "@NA/Icons/OrderDetailsArrowLeft";
import ADIColors from "@NA/Utils/ADIColors";
import getColor from "@insite/mobius/utilities/getColor";
import ADIXtenExportToXtenButton from "@NA/Components/ADIXtenExportToXtenButton";
import Hidden from "@insite/mobius/Hidden";
import { useEffect } from "react";

const mapStateToProps = (state: ApplicationState) => {
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    const urlparmOrderNumber  = state.pages.orderDetails.orderNumber;
    return {
        order,
        urlparmOrderNumber
    };
};

type Props = WidgetProps & HasProduct & HasHistory & ReturnType<typeof mapStateToProps>;

export interface ADIOrderDetailsPrintSectionStyles {
    wrapper?: InjectableCss;
    printButton?: ButtonPresentationProps;
    returnButton?: ButtonPresentationProps;
    returnButtonMobile?: ButtonPresentationProps;
}

export const adiOrderDetailsPrintSectionStyles: ADIOrderDetailsPrintSectionStyles = {
    returnButton: {
        variant: "secondary",
        css: css`
            min-width: 226px;
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            justify-content: center;
            border-radius: 4px;
            border: solid 1px ${getColor("secondary")};
            background: ${getColor("common.background")};
            svg{
                margin-right: 10px;
                height: 10px;
                width: 13px;
            }
            &:focus{
                outline: none;
            }
            &:hover{
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
            @media only screen and (max-width: 1024px) {
                display: none;
            }
        `
    },
    returnButtonMobile: {
        variant: "secondary",
        css: css`
            width: auto;
            min-width: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            border: solid 1px ${getColor("secondary")};
            background: ${getColor("common.background")};
            padding: 0 12px;
            display: none;
            svg{
                height: 13px;
                width: 16px;
            }
            &:focus{
                outline: none;
            }
            &:hover{
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
            
            @media only screen and (max-width: 1024px) {
                display: flex;
            }
        `
    },
    printButton: {
        variant: "secondary",
        css: css`
            margin-left: 20px;
            width: auto;
            min-width: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            border: solid 1px ${getColor("secondary")};
            background: ${getColor("common.background")};
            padding: 0 13px;
            svg{
                height: 20px;
                width: 20px;
            }
            &:focus{
                outline: none;
            }
            &:hover{
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
            @media only screen and (max-width: 1024px) {
                display: none;
            }
        `
    },
    wrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
};

const styles = adiOrderDetailsPrintSectionStyles;

const ADIOrderDetailsPrintSection: React.FC<Props> = ({ order, history, urlparmOrderNumber }) => {
    const onClick = () => {
        history.push("/MyAccount/Order");
    };

    const onClickPrint = () => {
        if (!order) {
            // return;
        }
        openPrintDialog();
    };

    const [id, setId] = React.useState('');
    useEffect(() => {        
        setId(urlparmOrderNumber || "");        
    }, [urlparmOrderNumber]);
    

    return (
        <StyledWrapper {...styles.wrapper}>
            <Button onClick={onClick} {...styles.returnButton}>
                <OrderDetailsArrowLeft />
                {translate("Return to My Orders")}
            </Button>
            <Button onClick={onClick} {...styles.returnButtonMobile}>
                <OrderDetailsArrowLeft />
            </Button>
            {order && 
                <Button {...styles.printButton} onClick={onClickPrint}>
                    <PrintIcon />                    
                </Button>
                
            }
            <Hidden below="sm">
                <ADIXtenExportToXtenButton                             
                                        id={id}
                                        type="orderdetail"
                                        buttonText=""
                                        />  
            </Hidden>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(ADIOrderDetailsPrintSection)),
    definition: {
        displayName: "ADI Order Details Print Section",
        group: "Order Details",
        allowedContexts: [OrderDetailsPageContext],
    },
};

export default widgetModule;